var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.422,
    height: 48,
    viewBox: "0 0 40.422 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5769",
    "data-name": "Group 5769",
    transform: "translate(10584.707 -6169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-stack-41649",
    transform: "translate(-10584.707 6169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6121",
    "data-name": "Path 6121",
    d: "M178.824,57.719H158.614a3.79,3.79,0,0,0-3.79,3.79V89.3a3.79,3.79,0,0,0,3.79,3.79h20.211a3.79,3.79,0,0,0,3.79-3.79V61.508a3.79,3.79,0,0,0-3.789-3.789ZM185.14,51.4H164.929a3.79,3.79,0,0,0-3.79,3.79H181.35a3.79,3.79,0,0,1,3.79,3.79V86.773a3.79,3.79,0,0,0,3.79-3.79V55.193a3.789,3.789,0,0,0-3.79-3.789Zm6.315-6.316h-20.21a3.79,3.79,0,0,0-3.79,3.79h20.211a3.79,3.79,0,0,1,3.79,3.79V80.456a3.79,3.79,0,0,0,3.79-3.79V48.878a3.79,3.79,0,0,0-3.79-3.79Z",
    transform: "translate(-154.824 -45.088)",
    fill: "#b0bec5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.e99978e224edc8532c57e096da32c885.svg";
export { ForwardRef as ReactComponent };